import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { OrderStatuses } from '@app/models';
import { ORDER_STATUS_CONFIG } from '../order-status.const';

@Component({
  selector: 'ui-order-icon',
  standalone: true,
  imports: [NgClass],
  templateUrl: './order-icon.component.html',
  styleUrl: './order-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderIconComponent {
  public readonly orderStatus = input.required<OrderStatuses>();

  protected readonly OrderStatuses = OrderStatuses;

  readonly config = computed(() => ORDER_STATUS_CONFIG[this.orderStatus()]);
}
